import {keyframes} from '@emotion/react'
import styled from '@emotion/styled'

import {cssTheme} from '@vio/atlas/themes'

const pulse = keyframes`
  0%, 100% {
    opacity: 0.2;
    transform: scale(1);
  }
  50% {
    opacity: 1;
    transform: scale(1.2);
  }
`

const DotContainer = styled.div`
  display: flex;
  align-items: center;
  gap: 4px;
`

const Dot = styled.div<{delay: number}>`
  width: 6px;
  height: 6px;
  border-radius: 50%;
  background-color: ${cssTheme.colors.background.neutral.inverseSecondary};
  animation: ${pulse} 0.6s ease-in-out ${({delay}) => delay}s infinite;
`

export const TypingDots = () => {
  return (
    <DotContainer>
      {[0, 0.2, 0.4].map((delay, index) => (
        <Dot key={index} delay={delay} />
      ))}
    </DotContainer>
  )
}
